var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site",attrs:{"id":"app"}},[_c('navbar'),_c('router-view',{staticClass:"site-content"}),_c('pagefooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }